import {
  HttpErrorResponse,
  HttpEventType,
  HttpInterceptorFn,
  HttpResponse,
} from '@angular/common/http';
import { catchError, tap, throwError } from 'rxjs';
import { environment } from '../../../environments/environment';

const formatUrl = (url: string, params: string): string =>
  params ? `${url}?${params}` : url;

export const apiDebugInterceptor: HttpInterceptorFn = (req, next) => {
  const requestUrl = formatUrl(req.url, req.params.toString());
  const startedAt = performance.now();

  return next(req).pipe(
    tap((event) => {
      if (event.type !== HttpEventType.Response) return;

      const response = event as HttpResponse<unknown>;
      const duration = Math.round(performance.now() - startedAt);

      console.log(`✅ [API] ${response.status} ${req.method} ${requestUrl} (${duration}ms)`);

      if (environment.debugApi) {
        console.dir(response.body, { depth: null, colors: true });
      }
    }),
    catchError((error: HttpErrorResponse) => {
      const duration = Math.round(performance.now() - startedAt);

      console.error(`❌ [API] ${error.status || 'NETWORK'} ${req.method} ${requestUrl} (${duration}ms)`);

      if (environment.debugApi) {
        console.dir(error.error, { depth: null, colors: true });
      }

      return throwError(() => error);
    }),
  );
};
